module.exports = "./img/4dcacd508e71d4599d37194a19641c5b.png";